import React, { useState } from 'react';
import ManagerSidebar from '../../components/Sidebar/ManagerSidebar';
import './TenantNotifications.css'; // Importing the responsive stylesheet

const TenantMessage = () => {
    const [showForm, setShowForm] = useState(false);

    const [email, setEmail] = useState('');
    const [messageText, setMessageText] = useState('');

    const [messages, setMessages] = useState([]);

    const [submitStatus, setSubmitStatus] = useState('');
    const [fetchStatus, setFetchStatus] = useState('');

    // EDIT STATES
    const [editingId, setEditingId] = useState(null);
    const [editedMessages, setEditedMessages] = useState({});

    // =========================
    // SEND MESSAGE
    // =========================
    const handleSendMessage = async () => {
        if (!email || !messageText) {
            setSubmitStatus('Email and message are required.');
            return;
        }

        try {
            const res = await fetch(
                'https://ikaze-thouse-backend.vercel.app/api/teMessage/messages',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        email,
                        message_text: messageText,
                    }),
                }
            );

            const data = await res.json();

            if (data.success) {
                setSubmitStatus('Message sent successfully!');
                setMessageText('');
                handleFetchMessages();
            } else {
                setSubmitStatus(data.message || 'Failed to send message.');
            }
        } catch (error) {
            console.log(error);
            setSubmitStatus('Error sending message.');
        }
    };

    // =========================
    // FETCH MESSAGES
    // =========================
    const handleFetchMessages = async () => {
        if (!email) {
            setFetchStatus('Please enter tenant email first.');
            return;
        }

        try {
            const res = await fetch(
                `https://ikaze-thouse-backend.vercel.app/api/teMessage/messages/${email}`
            );

            const data = await res.json();

            if (data.success) {
                setMessages(data.messages);
                setFetchStatus('');
            } else {
                setMessages([]);
                setFetchStatus(data.message || 'No messages found.');
            }
        } catch (error) {
            console.log(error);
            setFetchStatus('Error fetching messages.');
        }
    };

    // =========================
    // DELETE MESSAGE
    // =========================
    const handleDelete = async (id) => {
        const confirmDelete = window.confirm(
            'Are you sure you want to delete this message?'
        );

        if (!confirmDelete) return;

        try {
            const res = await fetch(
                `https://ikaze-thouse-backend.vercel.app/api/teMessage/messages/${id}`,
                { method: 'DELETE' }
            );

            const data = await res.json();

            if (data.success) {
                setMessages((prev) =>
                    prev.filter((msg) => msg.message_id !== id)
                );
            } else {
                alert(data.message || 'Delete failed.');
            }
        } catch (error) {
            console.log(error);
            alert('Error deleting message.');
        }
    };

    // =========================
    // START EDIT
    // =========================
    const startEditing = (msg) => {
        setEditingId(msg.message_id);

        setEditedMessages((prev) => ({
            ...prev,
            [msg.message_id]: msg.message_text,
        }));
    };

    // =========================
    // SAVE EDIT
    // =========================
    const saveEdit = async (id) => {
        try {
            const res = await fetch(
                `https://ikaze-thouse-backend.vercel.app/api/teMessage/messages/${id}`,
                {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        message_text: editedMessages[id],
                    }),
                }
            );

            const data = await res.json();

            if (data.success) {
                const updated = messages.map((msg) =>
                    msg.message_id === id
                        ? { ...msg, message_text: editedMessages[id] }
                        : msg
                );

                setMessages(updated);
                setEditingId(null);
            } else {
                alert(data.message || 'Update failed.');
            }
        } catch (error) {
            console.log(error);
            alert('Error updating message.');
        }
    };

    return (
        <div className="tm-main-container">
            <ManagerSidebar />

            <div className="tm-content">
                <div className="tm-container">
                    <h2 className="tm-title">Tenant Messages</h2>

                    {/* STATUS NOTIFICATION RENDERS */}
                    {submitStatus && <div className="tm-status-alert">{submitStatus}</div>}
                    {fetchStatus && <div className="tm-status-alert errors">{fetchStatus}</div>}

                    {/* EMAIL INPUT */}
                    <input
                        className="tm-input"
                        placeholder="Tenant Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    {/* MESSAGE INPUT */}
                    <textarea
                        className="tm-textarea"
                        placeholder="Write message..."
                        value={messageText}
                        onChange={(e) => setMessageText(e.target.value)}
                    />

                    <div className="tm-action-buttons-wrapper">
                        <button className="tm-button" onClick={handleSendMessage}>
                            Send
                        </button>

                        <button className="tm-button" onClick={handleFetchMessages}>
                            Load Messages
                        </button>
                    </div>

                    {/* MESSAGES */}
                    <div className="tm-messages-feed">
                        {messages.map((msg) => (
                            <div key={msg.message_id} className="tm-card">
                                <b className="tm-guest-name">{msg.Guest_Name}</b>

                                {editingId === msg.message_id ? (
                                    <>
                                        <textarea
                                            className="tm-textarea"
                                            value={editedMessages[msg.message_id] || ''}
                                            onChange={(e) =>
                                                setEditedMessages((prev) => ({
                                                    ...prev,
                                                    [msg.message_id]: e.target.value,
                                                }))
                                            }
                                        />

                                        <button
                                            className="tm-save-btn"
                                            onClick={() => saveEdit(msg.message_id)}
                                        >
                                            Save
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <p className="tm-message-text">{msg.message_text}</p>
                                        <small className="tm-message-date">
                                            {new Date(msg.created_at).toLocaleString()}
                                        </small>

                                        <div className="tm-card-actions">
                                            <button
                                                className="tm-edit-btn"
                                                onClick={() => startEditing(msg)}
                                            >
                                                Edit
                                            </button>

                                            <button
                                                className="tm-delete-btn"
                                                onClick={() => handleDelete(msg.message_id)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TenantMessage;